import {FC} from 'react'
import ReactMarkdown from 'react-markdown'
import {StyledMarkdownText} from '@components/commons/markdown-text/style.ts'

export const MarkdownText: FC<{content: string}> = ({content}) => (
    <StyledMarkdownText>
        <ReactMarkdown>{content}</ReactMarkdown>
    </StyledMarkdownText>
)
